import React, { useState, useEffect } from 'react';
import { FaShoppingCart } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
// API URL設定を直接埋め込み（Vercel対応）
const getApiUrl = () => {
  const RAILWAY_API = import.meta.env.VITE_API_URL || 'https://registration-app-production.up.railway.app';
  const LOCALHOST_API = 'http://localhost:3000';
  
  const isLocalhost = 
    window.location.hostname === 'localhost' ||
    window.location.hostname === '127.0.0.1';
  
  return isLocalhost ? LOCALHOST_API : RAILWAY_API;
};
const API_URL = getApiUrl();

/**
 * カートアイコンコンポーネント
 * ヘッダーやナビゲーションバーに配置するカートアイコン
 * カート内のアイテム数を表示し、カート画面への遷移を提供
 */
const CartIcon = ({ className = '' }) => {
  const [cartCount, setCartCount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  // カート数量を取得
  const fetchCartCount = async () => {
    try {
      setIsLoading(true);
      const token = localStorage.getItem('token');
      if (!token) return;

      const response = await axios.get(`${API_URL}/api/cart/list`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (response.data.success) {
        setCartCount(response.data.cartItems.length || 0);
      }
    } catch (error) {
      // カート数量取得エラー
      // エラーの場合はカウントを0に設定
      setCartCount(0);
    } finally {
      setIsLoading(false);
    }
  };

  // コンポーネントマウント時にカート数量を取得
  useEffect(() => {
    fetchCartCount();

    let debounceTimer;
    const debouncedFetch = () => {
      if (debounceTimer) clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => {
        fetchCartCount();
      }, 300);
    };

    // カート更新イベントをリスンする
    const handleCartUpdate = () => {
      debouncedFetch();
    };

    window.addEventListener('cartUpdated', handleCartUpdate);

    // カート画面から戻ってきた時も更新
    const handleVisibilityChange = () => {
      if (!document.hidden) {
        debouncedFetch();
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      if (debounceTimer) clearTimeout(debounceTimer);
      window.removeEventListener('cartUpdated', handleCartUpdate);
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);

  // カートアイコンクリックでカート画面に遷移
  const handleCartClick = () => {
    navigate('/cart');
  };

  return (
    <div
      className={`relative cursor-pointer hover:opacity-75 transition-opacity ${className}`}
      onClick={handleCartClick}
      title="カートを表示"
    >
      <FaShoppingCart className="text-2xl" />
      {cartCount > 0 && (
        <span className="absolute -top-2 -right-2 bg-red-500 text-white text-xs rounded-full h-5 w-5 flex items-center justify-center font-bold min-w-[20px]">
          {cartCount > 99 ? '99+' : cartCount}
        </span>
      )}
      {isLoading && (
        <div className="absolute -top-1 -right-1 w-3 h-3 border-2 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
      )}
    </div>
  );
};

export default CartIcon;
